import { Card } from "@common/components/ui/card"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { PageContent, PageTitle } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { CategoryForm } from "./-components/form/category-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/tool-categories/create",
)({
  staticData: { breadcrumb: "New tool category" },
  component: CreateCategoryPage,
})

function CreateCategoryPage(): React.ReactElement {
  const navigate = useNavigate()
  const showToast = useCustomToast()

  return (
    <PageContent>
      <PageTitle title="New tool category" />
      <Card className="p-4 shadow-none">
        <CategoryForm
          onCreate={(created) => {
            showToast("Created", `${created.name} added.`, "success")
            navigate({ to: "/settings/workspace/tool-categories" })
          }}
        />
      </Card>
    </PageContent>
  )
}
